<template>
  <v-dialog
    v-model="show"
    max-width="40vw"
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-6"
        >
          <v-row>
            <v-col
              md="12"
              cols="24"
            >
              <translation-fields
                v-model="translations"
                :fields="translatedFields"
              />
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js'
import { mapActions } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import TranslationFields from '@/components/translation-fields'

export default {
  name: 'ModifierGroupDetailsForm',
  components: { TranslationFields },
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    translatedFields: [
      { key: 'name', label: 'Наименование', required: true },
    ],
    icons: {
      mdiCheck,
      mdiClose,
    },
    rules,
  }),
  computed: {
    ...mapFormHandlers('modifierGroupDetailsTranslations/form', [
      'id',
      'translations',
    ]),
  },
  watch: {
    show(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('modifierGroupDetailsTranslations/form', ['resetForm']),
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
